<template>
  <v-dialog v-if="template && template.instructions"
            v-model="dialog"
            max-width="500"
            persistent>
    <v-card>
      <v-card-title>
        Instructions
      </v-card-title>
      <v-card-text>
        {{ template.instructions }}
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary"
               @click.prevent="closeInstructions">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    template: {
      type: Object,
      required: false,
    },
    dialog: {
      type:Boolean,
      required: true,
    }
  },
  methods: {
    closeInstructions() { // MLD-3031
      this.$emit('close');
    }
  }
}
</script>
